import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
	fullName: Yup.string().required('Required'),
	tinNumber: Yup.string().required('Required'),
	contactName: Yup.string().required('Required'),
	nominatedEmail: Yup.string().email('Invalid email').required('Required'),
	phone: Yup.string().required('Required'),
	registeredCountryId: Yup.number().required('Required'),
	registeredPostalCode: Yup.string().required('Required'),
	regAddressCity: Yup.string().required('Required'),
	regStreetNo: Yup.string().required('Required'),
	officialSiteUrl: Yup.string()
		.matches(/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/, 'Invalid URL')
		.required('Required'),
	ecommercePlatform: Yup.string().required('Required'),
	legalStatus: Yup.string().required('Required'),
	paymentHandlingMode: Yup.string().required('Required'),
	invoiceFeeTypeId: Yup.number().required('Required'),
	subscriptionPlanId: Yup.number().required('Required'),
});
